import { IconBuildingWarehouse, IconBook, IconUsers } from '@tabler/icons-react';

import { colors } from 'constants/colors';

import { CgScreenWide } from 'react-icons/cg';
import { FaAppleAlt, FaCoffee, FaHandshake, FaThermometerHalf, FaTruckLoading } from 'react-icons/fa';
import {
    FcAreaChart,
    FcBarChart,
    FcCalendar,
    FcCancel,
    FcConferenceCall,
    FcCurrencyExchange,
    FcDataConfiguration,
    FcDataRecovery,
    FcDeployment,
    FcDonate,
    FcExpired,
    FcFilledFilter,
    FcGrid,
    FcInTransit,
    FcInvite,
    FcList,
    FcMoneyTransfer,
    FcNeutralTrading,
    FcNews,
    FcOrganization,
    FcPaid,
    FcPlanner,
    FcSettings,
    FcShop,
    FcSms,
    FcStackOfPhotos,
    FcCalculator,
    FcCamera,
} from 'react-icons/fc';
import { BsFillQuestionDiamondFill } from 'react-icons/bs';
import { HiOutlineSwitchHorizontal } from 'react-icons/hi';
import { RiExchangeBoxLine, RiFridgeFill } from 'react-icons/ri';
import { IoBicycleOutline } from 'react-icons/io5';
import { GrPlan } from 'react-icons/gr';

enum PageName {
    advertisementScreenConfig = 'advertisementScreenConfig',
    advertisementScreenConfigLoggedOut = 'advertisementScreenConfigLoggedOut',
    badges = 'badges',
    badgeCreate = 'badgeCreate',
    badgeUpdate = 'badgeUpdate',
    bakeryRecords = 'bakeryRecords',
    bundles = 'bundles',
    bundleDetails = 'bundleDetails',
    categories = 'categories',
    categoryCreate = 'categoryCreate',
    categoryDetails = 'categoryDetails',
    credits = 'credits',
    creditCreate = 'creditCreate',
    comments = 'comments',
    deliveries = 'deliveries',
    deliveriesDailyPhoto = 'deliveriesDailyPhoto',
    deliveryPlanning = 'deliveryPlanning',
    deliveryPlanningSelectedDate = 'deliveryPlanningSelectedDate',
    dynamicDeliveryPlanning = 'dynamicDeliveryPlanning',
    dynamicDeliveryPlanningSelectedDate = 'dynamicDeliveryPlanningSelectedDate',
    tours = 'tours',
    toursSelectedDate = 'toursSelectedDate',
    tourDetails = 'tourDetails',
    deliveryDetails = 'deliveryDetails',
    forgotPassword = 'forgotPassword',
    resetPassword = 'resetPassword',
    expiredFutureStockVariations = 'expiredFutureStockVariations',
    expiryDateRecords = 'expiryDateRecords',
    equipments = 'equipments',
    equipmentDetails = 'equipmentDetails',
    equipmentCreate = 'equipmentCreate',
    futureStockVariations = 'futureStockVariations',
    trayCapacities = 'trayCapacities',
    hotDrinksRecipes = 'hotDrinksRecipes',
    hotDrinksRecipeDetails = 'hotDrinksRecipeDetails',
    hotDrinksRecipeCreate = 'hotDrinksRecipeCreate',
    locations = 'locations',
    supplierPartnerships = 'supplierPartnerships',
    manualSupplyOrders = 'manualSupplyOrders',
    menus = 'menus',
    menusDetails = 'menusDetails',
    menuQuantities = 'menuQuantities',
    menuProductArrangements = 'menuProductArrangements',
    messagesSets = 'messagesSets',
    messagesSetsCreate = 'messagesSetsCreate',
    messagesSetDetails = 'messagesSetDetails',
    microstoreColumns = 'microstoreColumns',
    microstoreColumnDetails = 'microstoreColumnDetails',
    microstoreColumnGroups = 'microstoreColumnGroups',
    microstoreColumnGroupDetails = 'microstoreColumnGroupDetails',
    microstoreColumnGroupTargetsInfo = 'microstoreColumnGroupTargetsInfo',
    microstoreColumnTemplates = 'microstoreColumnTemplates',
    microstoreColumnTemplateDetails = 'microstoreColumnTemplateDetails',
    microstorePlanogram = 'microstorePlanogram',
    microstoreSnapshot = 'microstoreSnapshot',
    mobilePopups = 'mobilePopups',
    notifications = 'notifications',
    notificationsOrganization = 'notificationsOrganization',
    notificationsSite = 'notificationsSite',
    notificationsUser = 'notificationsUser',
    nuBasket = 'nuBasket',
    opsParameters = 'opsParameters',
    orders = 'orders',
    orderDetails = 'orderDetails',
    organizations = 'organizations',
    organizationDetails = 'organizationDetails',
    organizationCreate = 'organizationCreate',
    totems = 'totems',
    totemDetails = 'totemDetails',
    microstoreColumnGroupPage = 'microstoreColumnGroupPage',
    polls = 'polls',
    pollCreate = 'pollCreate',
    pollDetails = 'pollDetails',
    products = 'products',
    productCreate = 'productCreate',
    productArrangements = 'productArrangements',
    productGroups = 'productGroups',
    productGroupDetails = 'productGroupDetails',
    productArrangementDetails = 'productArrangementDetails',
    productDetails = 'productDetails',
    productImport = 'productImport',
    productPriceRangeCreate = 'productPriceRangeCreate',
    productPriceRangeDetails = 'productPriceRangeDetails',
    productPriceRanges = 'productPriceRanges',
    productSwitches = 'productSwitches',
    quizzes = 'quizzes',
    quizCreate = 'quizCreate',
    quizDetails = 'quizDetails',
    ritualCreate = 'ritualCreate',
    ritualDetails = 'ritualDetails',
    rituals = 'rituals',
    ritualTemplates = 'ritualTemplates',
    settings = 'settings',
    sites = 'sites',
    siteCreate = 'siteCreate',
    siteImport = 'siteImport',
    siteDetails = 'siteDetails',
    siteMicrostoreColumnGroups = 'siteMicrostoreColumnGroups',
    siteExternalInventory = 'siteExternalInventory',
    siteSetups = 'siteSetups',
    siteSetupDetails = 'siteSetupDetails',
    siteStocks = 'siteStocks',
    stockTransfers = 'stockTransfers',
    stockTransferCreate = 'stockTransferCreate',
    stockTransferDetails = 'stockTransferDetails',
    stockTransferReturns = 'stockTransferReturns',
    stocks = 'stocks',
    siteInventoryStockCreate = 'siteInventoryStockCreate',
    stockVariationCreate = 'stockVariationCreate',
    stockVariationMultiCreate = 'stockVariationMultiCreate',
    stockVariationsByDay = 'stockVariationsByDay',
    columnStocks = 'columnStocks',
    columnProductStocks = 'columnProductStocks',
    subventions = 'subventions',
    subventionCreate = 'subventionCreate',
    subventionDetails = 'subventionDetails',
    suppliers = 'suppliers',
    supplierCreate = 'supplierCreate',
    supplierDetails = 'supplierDetails',
    supplyOrders = 'supplyOrders',
    supplyOrderDetails = 'supplyOrderDetails',
    supplyOrderConfirmation = 'supplyOrderConfirmation',
    supplierDiscounts = 'supplierDiscounts',
    tags = 'tags',
    tagCreate = 'tagCreate',
    tagUpdate = 'tagUpdate',
    thermometers = 'thermometers',
    transactions = 'transactions',
    transactionCreate = 'transactionCreate',
    transactionDetails = 'transactionDetails',
    termsRecords = 'termsRecords',
    termsRecordCreate = 'termsRecordCreate',
    totemClosedDays = 'totemClosedDays',
    totemClosedReceptionDays = 'totemClosedReceptionDays',
    urbantzRoundPresets = 'urbantzRoundPresets',
    users = 'users',
    userCreateToteam = 'userCreateToteam',
    userCreatedTotops = 'userCreatedTotops',
    userDetails = 'userDetails',
    senseiBasket = 'senseiBasket',
    setPassword = 'setPassword',
    passwordDefined = 'passwordDefined',
    warehouseDeliveries = 'warehouseDeliveries',
    warehouseDeliveryDetails = 'warehouseDeliveryDetails',
    warehouseReturns = 'warehouseReturns',
    warehouseReturnDetails = 'warehouseReturnDetails',
    nayaxMDBTemplates = 'nayaxMDBTemplates',
    nayaxMDBTemplateDetails = 'nayaxMDBTemplateDetails',
    deliveryZones = 'deliveryZones',
    deliveryZoneDetails = 'deliveryZoneDetails',
}

export enum NavSection {
    WarehouseManagementSystem = 'WarehouseManagementSystem',
    CatalogManagementSystem = 'CatalogManagementSystem',
    CustomerManagementSystem = 'CustomerManagementSystem',
}

export const NAV_SECTION_LABELS = {
    [NavSection.WarehouseManagementSystem]: 'Warehouse Management System',
    [NavSection.CatalogManagementSystem]: 'Catalog Management System',
    [NavSection.CustomerManagementSystem]: 'Customer Management System',
};

export const NAV_SECTION_ICONS = {
    [NavSection.WarehouseManagementSystem]: <IconBuildingWarehouse />,
    [NavSection.CatalogManagementSystem]: <IconBook />,
    [NavSection.CustomerManagementSystem]: <IconUsers />,
};

export type PageType = {
    icon?: JSX.Element;
    label: string;
    section: PageName;
    shortLabel?: string;
    url: string;
    navSection?: NavSection;
};

export const PAGES: Record<PageName, PageType> = {
    advertisementScreenConfig: {
        icon: <CgScreenWide />,
        label: 'Écran publicitaire',
        section: PageName.advertisementScreenConfig,
        url: '/advertisement-screen-config',
        navSection: NavSection.CustomerManagementSystem,
    },
    advertisementScreenConfigLoggedOut: {
        label: 'Écran publicitaire',
        section: PageName.advertisementScreenConfig,
        url: '/advertisement-screen-config/logged-out',
    },
    badges: {
        icon: <FcFilledFilter />,
        label: 'Badges',
        section: PageName.badges,
        url: '/badges',
        navSection: NavSection.CatalogManagementSystem,
    },
    badgeCreate: {
        icon: <FcFilledFilter />,
        label: 'Badges',
        section: PageName.badges,
        url: '/badge/create',
    },
    badgeUpdate: {
        icon: <FcFilledFilter />,
        label: 'Badges',
        section: PageName.badges,
        url: '/badge/:badgeId',
    },
    bakeryRecords: {
        icon: <>🥐</>,
        label: 'Suivi de cuisson viennoiseries',
        section: PageName.bakeryRecords,
        url: '/bakery-records',
        navSection: NavSection.WarehouseManagementSystem,
    },
    bundles: {
        icon: <FcDeployment />,
        label: 'Bundles',
        section: PageName.bundles,
        url: '/bundles',
        navSection: NavSection.WarehouseManagementSystem,
    },
    bundleDetails: {
        icon: <FcDeployment />,
        label: "Détails d'un bundle",
        section: PageName.bundles,
        url: '/bundle/:bundleId',
    },
    categories: {
        icon: <FcList />,
        label: 'Catégories',
        section: PageName.categories,
        url: '/categories',
        navSection: NavSection.CatalogManagementSystem,
    },
    categoryCreate: {
        icon: <FcList />,
        label: 'Créer une catégorie',
        section: PageName.categories,
        url: '/category/create',
    },
    categoryDetails: {
        icon: <FcList />,
        label: "Détails d'une catégorie",
        section: PageName.categories,
        url: '/category/:categoryId',
    },
    credits: {
        icon: <FcDonate />,
        label: 'Crédits',
        section: PageName.credits,
        url: '/credits',
        navSection: NavSection.CustomerManagementSystem,
    },
    creditCreate: {
        icon: <FcDonate />,
        label: 'Créer un crédit',
        section: PageName.credits,
        url: '/credit/create',
    },
    comments: {
        icon: <FcConferenceCall />,
        label: 'Commentaires',
        section: PageName.comments,
        url: '/comments',
        navSection: NavSection.CustomerManagementSystem,
    },
    deliveries: {
        icon: <FcInTransit />,
        label: 'Livraisons',
        section: PageName.deliveries,
        url: '/deliveries',
        navSection: NavSection.WarehouseManagementSystem,
    },
    deliveriesDailyPhoto: {
        icon: <FcCamera />,
        label: 'Contrôle de photos',
        section: PageName.deliveriesDailyPhoto,
        url: '/deliveries-daily-photos',
        navSection: NavSection.WarehouseManagementSystem,
    },
    deliveryPlanning: {
        icon: <FcPlanner />,
        label: 'Planning de livraison',
        section: PageName.deliveryPlanning,
        url: '/delivery-planning',
        navSection: NavSection.WarehouseManagementSystem,
    },
    tours: {
        icon: <FcInTransit />,
        label: 'Tournées',
        section: PageName.tours,
        url: '/tours',
        navSection: NavSection.WarehouseManagementSystem,
    },
    toursSelectedDate: {
        label: 'Tournées',
        section: PageName.tours,
        url: '/tours/:selectedDate',
    },
    tourDetails: {
        icon: <FcInTransit />,
        label: "Détails d'une tournée",
        section: PageName.tours,
        url: '/tour/:tourId',
    },
    deliveryPlanningSelectedDate: {
        label: 'Planning de livraison',
        section: PageName.deliveryPlanning,
        url: '/delivery-planning/:selectedDate',
    },
    dynamicDeliveryPlanning: {
        icon: <FcPlanner />,
        label: 'Planning de livraison dynamique',
        section: PageName.dynamicDeliveryPlanning,
        url: '/dynamic-delivery-planning',
        navSection: NavSection.WarehouseManagementSystem,
    },
    dynamicDeliveryPlanningSelectedDate: {
        label: 'Planning de livraison dynamique',
        section: PageName.dynamicDeliveryPlanning,
        url: '/dynamic-delivery-planning/:selectedDate',
    },
    deliveryDetails: {
        icon: <FcInTransit />,
        label: "Détails d'une livraison",
        section: PageName.deliveries,
        url: '/delivery/:deliveryId',
    },
    equipments: {
        icon: <FaCoffee color={colors.blueOutline} />,
        label: 'Équipements',
        section: PageName.equipments,
        url: '/equipments',
        navSection: NavSection.CatalogManagementSystem,
    },
    equipmentDetails: {
        label: "Détails d'un équipement",
        section: PageName.equipments,
        url: '/equipment/:equipmentId',
    },
    equipmentCreate: {
        label: "Création d'un équipement",
        section: PageName.equipments,
        url: '/equipment/create',
    },
    expiredFutureStockVariations: {
        label: 'Variations de stock à venir expirées',
        section: PageName.stocks,
        url: '/stock-variation/expired-future-stock-variations',
    },
    expiryDateRecords: {
        icon: <FcExpired />,
        label: 'Date limite de consommation',
        section: PageName.expiryDateRecords,
        shortLabel: 'DLC',
        url: '/expiry-date-records',
        navSection: NavSection.WarehouseManagementSystem,
    },
    forgotPassword: {
        label: 'Mot de passe oublié',
        section: PageName.forgotPassword,
        url: '/recover-password',
    },
    resetPassword: {
        label: 'Réinitialiser le mot de passe',
        section: PageName.resetPassword,
        url: '/recover-password/:token',
    },
    futureStockVariations: {
        icon: <FcAreaChart />,
        label: 'Variations de stock à venir',
        section: PageName.stocks,
        url: '/stock-variation/future-stock-variations',
    },
    trayCapacities: {
        icon: <FaCoffee color={colors.orange} />,
        label: 'Capacités Bacs',
        shortLabel: 'Bacs',
        section: PageName.trayCapacities,
        url: '/tray-capacities',
        navSection: NavSection.WarehouseManagementSystem,
    },
    hotDrinksRecipes: {
        icon: <FaCoffee color={colors.orange} />,
        label: 'Recettes Machine à Café',
        shortLabel: 'Recettes Machine à Café',
        section: PageName.hotDrinksRecipes,
        url: '/hot-drinks-recipes',
        navSection: NavSection.CatalogManagementSystem,
    },
    hotDrinksRecipeDetails: {
        icon: <FaCoffee color={colors.orange} />,
        label: 'Recette Machine à Café',
        section: PageName.hotDrinksRecipes,
        url: '/hot-drinks-recipe/:hotDrinksRecipeId',
    },
    hotDrinksRecipeCreate: {
        icon: <FaCoffee color={colors.orange} />,
        label: 'Créer une recette',
        section: PageName.hotDrinksRecipes,
        url: '/hot-drinks-recipe/create',
    },
    locations: {
        icon: <FcGrid />,
        label: 'Emplacements entrepôt',
        section: PageName.locations,
        shortLabel: 'Emplacements',
        url: '/locations',
        navSection: NavSection.WarehouseManagementSystem,
    },
    supplierPartnerships: {
        icon: <RiExchangeBoxLine />,
        label: 'Trades Marketing',
        section: PageName.supplierPartnerships,
        url: '/supplier-partnerships',
        navSection: NavSection.CustomerManagementSystem,
    },
    manualSupplyOrders: {
        icon: <FcCalculator />,
        label: 'Achats manuels',
        section: PageName.manualSupplyOrders,
        url: '/manual-supply-orders',
        navSection: NavSection.WarehouseManagementSystem,
    },
    menus: {
        icon: <FcCalendar />,
        label: 'Menus store',
        section: PageName.menus,
        shortLabel: 'Menus',
        url: '/menus',
        navSection: NavSection.CatalogManagementSystem,
    },
    menusDetails: {
        icon: <FcCalendar />,
        label: 'Détail menus store',
        section: PageName.menus,
        url: '/menus-details/:siteId/:selectedDate',
    },
    menuQuantities: {
        icon: <FcCalendar />,
        label: 'Quantités menus store',
        section: PageName.menus,
        url: '/menu-quantities/:selectedDate',
    },
    menuProductArrangements: {
        icon: <FcCalendar />,
        label: 'Arrangements menus store',
        section: PageName.menuProductArrangements,
        url: '/menu-product-arrangements/:selectedDate',
    },
    messagesSets: {
        icon: <FcSms />,
        label: 'Séries de messages',
        section: PageName.messagesSets,
        shortLabel: 'Messages Rituels',
        url: '/messages-sets',
    },
    messagesSetsCreate: {
        icon: <FcSms />,
        label: 'Créer une série de messages',
        section: PageName.messagesSets,
        shortLabel: 'Messages Rituels',
        url: '/messages-sets/create',
    },
    messagesSetDetails: {
        icon: <FcSms />,
        label: 'Détails de la série',
        section: PageName.messagesSetDetails,
        shortLabel: 'Détails Messages',
        url: '/messages-set/:messagesSetId',
    },
    microstoreColumns: {
        icon: <FcDataRecovery />,
        label: 'Colonnes microstore',
        section: PageName.microstoreColumns,
        shortLabel: 'MS Colonnes',
        url: '/microstore-columns',
        navSection: NavSection.WarehouseManagementSystem,
    },
    microstoreColumnDetails: {
        icon: <FcDataRecovery />,
        label: "Détails d'une MS colonne",
        section: PageName.microstoreColumns,
        url: '/microstore-column/:microstoreColumnId',
    },
    microstoreColumnGroups: {
        icon: <FcDataRecovery />,
        label: 'Groupe de microstore colonnes',
        section: PageName.microstoreColumnGroups,
        shortLabel: 'MS Groupes',
        url: '/microstore-column-groups',
        navSection: NavSection.WarehouseManagementSystem,
    },
    microstoreColumnGroupDetails: {
        icon: <FcDataRecovery />,
        label: "Détails des colonnes d'un microstore",
        section: PageName.microstoreColumnGroups,
        url: '/microstore-column-groups/:siteId',
    },
    microstoreColumnGroupTargetsInfo: {
        icon: <FcDataRecovery />,
        label: 'Remplissage des stocks cibles des microstores',
        section: PageName.microstoreColumnGroups,
        url: '/microstore-column-groups/targets-info',
    },
    microstoreColumnTemplates: {
        icon: <FcDataConfiguration />,
        label: 'Templates de colonne microstore',
        section: PageName.microstoreColumnTemplates,
        shortLabel: 'MS Cl. Templates',
        url: '/microstore-column-templates',
        navSection: NavSection.CatalogManagementSystem,
    },
    microstoreColumnTemplateDetails: {
        icon: <FcDataConfiguration />,
        label: "Détails d'un template de colonne microstore",
        section: PageName.microstoreColumnTemplates,
        url: '/microstore-column-template/:microstoreColumnTemplateId',
    },
    microstorePlanogram: {
        icon: <GrPlan />,
        label: 'Planogramme',
        section: PageName.microstoreColumnGroups,
        url: '/planogram/:siteId',
    },
    microstoreSnapshot: {
        icon: <FcDataRecovery />,
        label: 'Snapshot Microstore',
        section: PageName.microstoreSnapshot,
        url: '/microstore-snapshot/:siteId',
    },
    mobilePopups: {
        icon: <FcDataRecovery />,
        label: 'Popups mobile',
        section: PageName.mobilePopups,
        url: '/mobile-popups',
        navSection: NavSection.CustomerManagementSystem,
    },
    nayaxMDBTemplates: {
        icon: <FcShop />,
        label: 'Templates MDB Nayax',
        section: PageName.nayaxMDBTemplates,
        url: '/nayax-mdb-templates',
        navSection: NavSection.WarehouseManagementSystem,
    },
    nayaxMDBTemplateDetails: {
        icon: <FcShop />,
        label: "Détails d'un template MDB Nayax",
        section: PageName.nayaxMDBTemplates,
        url: '/nayax-mdb-template/:nayaxMDBTemplateId',
    },
    notifications: {
        icon: <FcInvite />,
        label: 'Notifications',
        section: PageName.notifications,
        url: '/notifications',
        navSection: NavSection.CustomerManagementSystem,
    },
    notificationsOrganization: {
        icon: <FcInvite />,
        label: 'Notifier une organisation',
        section: PageName.notifications,
        url: '/notifications/organization',
    },
    notificationsSite: {
        icon: <FcInvite />,
        label: 'Notifier un site',
        section: PageName.notifications,
        url: '/notifications/site',
    },
    notificationsUser: {
        icon: <FcInvite />,
        label: 'Notifier un utilisateur',
        section: PageName.notifications,
        url: '/notifications/user',
    },
    opsParameters: {
        icon: <FcSettings />,
        label: 'Paramètres Ops',
        section: PageName.opsParameters,
        url: '/ops-parameters',
        navSection: NavSection.WarehouseManagementSystem,
    },
    deliveryZones: {
        icon: <FcInTransit />,
        label: 'Zones de livraison',
        section: PageName.deliveryZones,
        url: '/delivery-zones',
        navSection: NavSection.WarehouseManagementSystem,
    },
    deliveryZoneDetails: {
        icon: <FcInTransit />,
        label: 'Zone de livraison',
        section: PageName.deliveryZones,
        url: '/delivery-zone/:deliveryZoneId',
    },
    orders: {
        icon: <FcPaid />,
        label: 'Commandes',
        section: PageName.orders,
        url: '/orders',
        navSection: NavSection.CustomerManagementSystem,
    },
    orderDetails: {
        icon: <FcPaid />,
        label: "Détails d'une commande",
        section: PageName.orders,
        url: '/order/:orderId',
    },
    organizations: {
        icon: <FcOrganization />,
        label: 'Organisations',
        section: PageName.organizations,
        url: '/organizations',
        navSection: NavSection.CustomerManagementSystem,
    },
    organizationCreate: {
        icon: <FcOrganization />,
        label: 'Créer une organisation',
        section: PageName.organizations,
        url: '/organization/create',
    },
    organizationDetails: {
        icon: <FcOrganization />,
        label: "Détails d'une organisation",
        section: PageName.organizations,
        url: '/organization/:organizationId',
    },
    totems: {
        icon: <FcOrganization />,
        label: 'Totems',
        section: PageName.totems,
        shortLabel: 'Totems',
        url: '/totems',
        navSection: NavSection.CustomerManagementSystem,
    },
    totemDetails: {
        icon: <FcOrganization />,
        label: "Détails d'un totem",
        section: PageName.totemDetails,
        url: '/totem/:totemId',
    },
    microstoreColumnGroupPage: {
        icon: <FcDataRecovery />,
        label: "Détails d'un groupe de colonnes",
        section: PageName.microstoreColumnGroupPage,
        url: '/microstore-column-group/:columnGroupId',
    },
    polls: {
        icon: <FcBarChart />,
        label: 'Sondages',
        section: PageName.polls,
        url: '/polls',
        navSection: NavSection.CustomerManagementSystem,
    },
    pollCreate: {
        icon: <FcBarChart />,
        label: 'Créer un sondage',
        section: PageName.polls,
        url: '/poll/create',
    },
    pollDetails: {
        icon: <FcBarChart />,
        label: "Détails d'un sondage",
        section: PageName.polls,
        url: '/poll/:pollId',
    },
    products: {
        icon: <FaAppleAlt color={colors.red} />,
        label: 'Produits',
        section: PageName.products,
        url: '/products',
        navSection: NavSection.CatalogManagementSystem,
    },
    productCreate: {
        icon: <FaAppleAlt color={colors.red} />,
        label: 'Créer un produit',
        section: PageName.products,
        url: '/product/create',
    },
    productDetails: {
        icon: <FaAppleAlt color={colors.red} />,
        label: "Détails d'un produit",
        section: PageName.products,
        url: '/product/:productId',
    },
    productImport: {
        icon: <FaAppleAlt color={colors.red} />,
        label: 'Imports CSV de produit',
        section: PageName.products,
        url: '/product/imports',
    },
    productGroups: {
        icon: <FaAppleAlt color={colors.red} />,
        label: 'Regroupements de produits',
        section: PageName.productGroups,
        url: '/product-groups',
    },
    productGroupDetails: {
        icon: <FaAppleAlt color={colors.red} />,
        label: "Détails d'un regroupement de produits",
        section: PageName.productGroups,
        url: '/product-group/:productGroupId',
    },
    productArrangements: {
        icon: <FaAppleAlt color={colors.red} />,
        label: 'Gamme de produit',
        section: PageName.productArrangements,
        url: '/product-arrangements',
        navSection: NavSection.CatalogManagementSystem,
    },
    productArrangementDetails: {
        icon: <FaAppleAlt color={colors.red} />,
        label: "Détails d'une gamme de produit",
        section: PageName.productArrangements,
        url: '/product-arrangement/:productArrangementId',
    },
    productPriceRanges: {
        icon: <FcMoneyTransfer />,
        label: 'Gammes de prix',
        section: PageName.productPriceRanges,
        url: '/product-price-ranges',
        navSection: NavSection.CatalogManagementSystem,
    },
    productPriceRangeCreate: {
        icon: <FcMoneyTransfer />,
        label: 'Créer une gamme de prix',
        section: PageName.productPriceRanges,
        url: '/product-price-range/create',
    },
    productPriceRangeDetails: {
        icon: <FcMoneyTransfer />,
        label: "Détails d'une gamme de prix",
        section: PageName.productPriceRanges,
        url: '/product-price-range/:rangeId',
    },
    productSwitches: {
        icon: <HiOutlineSwitchHorizontal />,
        label: 'Switch de produit (béta)',
        section: PageName.productSwitches,
        url: '/product-switches',
        navSection: NavSection.WarehouseManagementSystem,
    },
    quizzes: {
        icon: <BsFillQuestionDiamondFill />,
        label: 'Quiz',
        section: PageName.quizzes,
        url: '/quizzes',
        navSection: NavSection.CustomerManagementSystem,
    },
    quizCreate: {
        icon: <BsFillQuestionDiamondFill />,
        label: 'Créer un quiz',
        section: PageName.quizzes,
        url: '/quiz/create',
    },
    quizDetails: {
        icon: <BsFillQuestionDiamondFill />,
        label: "Détails d'un quiz",
        section: PageName.quizzes,
        url: '/quiz/:quizId',
    },
    ritualCreate: {
        icon: <FcPlanner />,
        label: 'Créer un rituel',
        section: PageName.rituals,
        url: '/ritual/create',
    },
    ritualDetails: {
        icon: <FcPlanner />,
        label: "Détails d'un rituel",
        section: PageName.rituals,
        url: '/ritual/:ritualId',
    },
    rituals: {
        icon: <FcPlanner />,
        label: 'Rituels',
        section: PageName.rituals,
        url: '/rituals',
        navSection: NavSection.CustomerManagementSystem,
    },
    ritualTemplates: {
        icon: <FcStackOfPhotos />,
        label: 'Rituels (Modèles)',
        section: PageName.ritualTemplates,
        url: '/ritual-templates',
        navSection: NavSection.CustomerManagementSystem,
    },
    settings: {
        icon: <FcSettings />,
        label: 'Paramètres',
        section: PageName.settings,
        url: '/settings',
    },
    sites: {
        icon: <FcShop />,
        label: 'Sites',
        section: PageName.sites,
        url: '/sites',
        navSection: NavSection.CustomerManagementSystem,
    },
    siteCreate: {
        icon: <FcShop />,
        label: 'Créer un site',
        section: PageName.sites,
        url: '/site/create',
    },
    siteImport: {
        icon: <FcShop />,
        label: 'Imports CSV de site',
        section: PageName.sites,
        url: '/site/imports',
    },
    siteDetails: {
        icon: <FcShop />,
        label: "Détails d'un site",
        section: PageName.sites,
        url: '/site/:siteId',
    },
    siteMicrostoreColumnGroups: {
        icon: <FcDataRecovery />,
        label: 'Arborescence des groupes microstore',
        section: PageName.sites,
        url: '/site/:siteId/microstore-column-groups',
    },
    siteExternalInventory: {
        icon: <FcShop />,
        label: 'Ventes Connues Site',
        section: PageName.siteExternalInventory,
        url: '/site-known-sales-inventory',
        navSection: NavSection.WarehouseManagementSystem,
    },
    siteSetups: {
        icon: <RiFridgeFill />,
        label: 'Rangement des sites',
        shortLabel: 'Rangement Sites',
        section: PageName.siteSetups,
        url: '/site-setups',
        navSection: NavSection.WarehouseManagementSystem,
    },
    siteSetupDetails: {
        icon: <RiFridgeFill />,
        label: 'Rangement du site',
        section: PageName.siteSetups,
        url: '/site-setup/:siteSetupId',
    },
    subventions: {
        icon: <FaHandshake color={colors.yellow} />,
        label: 'Subventions',
        section: PageName.subventions,
        url: '/subventions',
        navSection: NavSection.CustomerManagementSystem,
    },
    subventionCreate: {
        icon: <FaHandshake color={colors.yellow} />,
        label: 'Créer une subvention',
        section: PageName.subventions,
        url: '/subvention/create',
    },
    subventionDetails: {
        icon: <FaHandshake color={colors.yellow} />,
        label: "Détails d'une subvention",
        section: PageName.subventions,
        url: '/subvention/:subventionId',
    },
    suppliers: {
        icon: <FaHandshake color={colors.yellow} />,
        label: 'Fournisseurs',
        section: PageName.suppliers,
        url: '/suppliers',
        navSection: NavSection.CatalogManagementSystem,
    },
    supplierCreate: {
        icon: <FaHandshake color={colors.yellow} />,
        label: 'Créer un fournisseur',
        section: PageName.suppliers,
        url: '/supplier/create',
    },
    supplierDetails: {
        icon: <FaHandshake color={colors.yellow} />,
        label: "Détail d'un fournisseur",
        section: PageName.suppliers,
        url: '/supplier/:supplierId',
    },
    supplyOrders: {
        icon: <FaTruckLoading color={colors.blue} />,
        label: 'Achats',
        section: PageName.supplyOrders,
        url: '/supply-orders',
        navSection: NavSection.WarehouseManagementSystem,
    },
    supplyOrderDetails: {
        icon: <FaTruckLoading color={colors.blue} />,
        label: "Détails d'un achat",
        section: PageName.supplyOrders,
        url: '/supply-order/:supplyOrderId',
    },
    supplyOrderConfirmation: {
        icon: <FaHandshake color={colors.blue} />,
        label: "Confirmation de commande d'achat",
        section: PageName.supplyOrderConfirmation,
        url: '/supply-order-confirmation/:token',
    },
    supplierDiscounts: {
        icon: <FaHandshake color={colors.yellow} />,
        label: 'Remises fournisseurs',
        section: PageName.supplierDiscounts,
        url: '/supplier-discounts',
        navSection: NavSection.CatalogManagementSystem,
    },
    stockTransfers: {
        icon: <FcNeutralTrading />,
        label: 'Transferts de stock',
        section: PageName.stockTransfers,
        url: '/stock-transfers',
        navSection: NavSection.WarehouseManagementSystem,
    },
    stockTransferCreate: {
        icon: <FcNeutralTrading />,
        label: 'Créer un transfert de stock',
        section: PageName.stockTransfers,
        url: '/stock-transfer/create',
    },
    stockTransferDetails: {
        icon: <FcNeutralTrading />,
        label: "Détails d'un transfert de stock",
        section: PageName.stockTransfers,
        url: '/stock-transfer/:stockTransferId',
    },
    stockTransferReturns: {
        icon: <FcNeutralTrading />,
        label: "Consulter les retours à l'entrepôt",
        section: PageName.stockTransfers,
        url: '/stock-transfer/returns',
    },
    stocks: {
        icon: <FcAreaChart />,
        label: 'Stocks',
        section: PageName.stocks,
        url: '/stocks',
        navSection: NavSection.WarehouseManagementSystem,
    },
    stockVariationsByDay: {
        icon: <FcAreaChart />,
        label: 'Variations de stock par jour',
        section: PageName.stockVariationsByDay,
        url: '/stock-variations-by-day',
    },
    siteStocks: {
        icon: <FcAreaChart />,
        label: 'Colonnes du site',
        section: PageName.stocks,
        url: '/site/:siteId/stocks',
    },
    columnStocks: {
        icon: <FcAreaChart />,
        label: 'Stocks de la colonne',
        section: PageName.stocks,
        url: '/column/:columnId/stocks',
    },
    columnProductStocks: {
        icon: <FcAreaChart />,
        label: 'Historique de stock du produit',
        section: PageName.stocks,
        url: '/column/:columnId/stocks/:productId',
    },
    siteInventoryStockCreate: {
        icon: <FcAreaChart />,
        label: 'Inventorier un produit',
        section: PageName.stocks,
        url: '/site-inventory-stock/create',
    },
    stockVariationCreate: {
        icon: <FcAreaChart />,
        label: 'Créer une variation de stock',
        section: PageName.stocks,
        url: '/stock-variation/create',
    },
    stockVariationMultiCreate: {
        icon: <FcAreaChart />,
        label: 'Créer des variations de stock',
        section: PageName.stocks,
        url: '/stock-variation/create/multi',
    },
    tags: {
        icon: <FcDonate />,
        label: 'Tags',
        section: PageName.tags,
        url: '/tags',
        navSection: NavSection.CatalogManagementSystem,
    },
    tagCreate: {
        icon: <FcDonate />,
        label: 'Tag',
        section: PageName.tags,
        url: '/tag/create',
    },
    tagUpdate: {
        icon: <FcDonate />,
        label: 'Tag',
        section: PageName.tags,
        url: '/tag/:tagId',
    },
    termsRecords: {
        icon: <FcNews />,
        label: 'CGV',
        section: PageName.termsRecords,
        url: '/terms-records',
        navSection: NavSection.CustomerManagementSystem,
    },
    termsRecordCreate: {
        icon: <FcNews />,
        label: 'Créer une nouvelle version des CGV',
        section: PageName.termsRecords,
        url: '/terms-record/create',
    },
    thermometers: {
        icon: <FaThermometerHalf />,
        label: 'Thermomètres',
        section: PageName.thermometers,
        url: '/thermometers',
        navSection: NavSection.WarehouseManagementSystem,
    },
    transactions: {
        icon: <FcCurrencyExchange />,
        label: 'Transactions',
        section: PageName.transactions,
        url: '/transactions',
        navSection: NavSection.CustomerManagementSystem,
    },
    transactionCreate: {
        icon: <FcCurrencyExchange />,
        label: 'Créer une transaction',
        section: PageName.transactions,
        url: '/transaction/create',
    },
    transactionDetails: {
        icon: <FcCurrencyExchange />,
        label: "Détails d'une transaction",
        section: PageName.transactions,
        url: '/transaction/:transactionId',
    },
    totemClosedDays: {
        icon: <FcCancel />,
        label: 'Jours de fermeture Totem',
        section: PageName.totemClosedDays,
        url: '/totem-closed-days',
        navSection: NavSection.CustomerManagementSystem,
    },
    totemClosedReceptionDays: {
        icon: <FcCancel />,
        label: 'Jours de non-réception fresh Totem',
        section: PageName.totemClosedReceptionDays,
        url: '/totem-closed-reception-days',
        navSection: NavSection.WarehouseManagementSystem,
    },
    urbantzRoundPresets: {
        icon: <IoBicycleOutline />,
        label: 'Tournées prédéfinies',
        section: PageName.urbantzRoundPresets,
        url: '/urbantz-round-presets',
        navSection: NavSection.WarehouseManagementSystem,
    },
    users: {
        icon: <FcConferenceCall />,
        label: 'Utilisateurs',
        section: PageName.users,
        url: '/users',
        navSection: NavSection.CustomerManagementSystem,
    },
    userCreateToteam: {
        icon: <FcConferenceCall />,
        label: 'Créer un utilisateur Toteam',
        section: PageName.users,
        url: '/user/create-toteam',
    },
    userCreatedTotops: {
        icon: <FcConferenceCall />,
        label: 'Utilisateur Totops créé',
        section: PageName.users,
        url: '/user/created-totops',
    },
    userDetails: {
        icon: <FcConferenceCall />,
        label: "Détails d'un utilisateur",
        section: PageName.users,
        url: '/user/:userId',
    },
    senseiBasket: {
        icon: <FcConferenceCall />,
        label: 'Panier Sensei',
        section: PageName.users,
        url: '/sensei-basket/:basketId',
    },
    setPassword: {
        label: 'Définir mon mot de passe',
        section: PageName.setPassword,
        url: '/set-password/:token',
    },
    passwordDefined: {
        label: 'Mot de passe défini',
        section: PageName.passwordDefined,
        url: '/totops-password-defined',
    },
    nuBasket: {
        icon: <FcCurrencyExchange />,
        label: 'Panier',
        section: PageName.transactions,
        url: '/basket/:nuBasketId',
    },
    warehouseDeliveries: {
        icon: <FcInTransit />,
        label: 'Livraisons-entrepot',
        section: PageName.warehouseDeliveries,
        url: '/warehouse-deliveries',
        navSection: NavSection.WarehouseManagementSystem,
    },
    warehouseDeliveryDetails: {
        icon: <FcInTransit />,
        label: 'Livraisons-entrepot',
        section: PageName.warehouseDeliveries,
        url: '/warehouse-delivery/:warehouseDeliveryId',
    },
    warehouseReturns: {
        icon: <RiFridgeFill />,
        label: 'Retours Entrepôt',
        section: PageName.warehouseReturns,
        url: '/warehouse-returns',
        navSection: NavSection.WarehouseManagementSystem,
    },
    warehouseReturnDetails: {
        icon: <RiFridgeFill />,
        label: 'Retour Entrepôt',
        section: PageName.warehouseReturns,
        url: '/warehouse-return/:warehouseReturnId',
    },
};
